import * as walletTypes from "../types/account_wallet_types";

const initialState = {
  loading: false,
  data: {},
  billingDetails : {}
};

export default function walletReducer(state = initialState, action = {}) {
  switch (action.type) {
    case walletTypes.getWalletInfo.GET_WALLET_INFO_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case walletTypes.getWalletInfo.GET_WALLET_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
      };
    case walletTypes.getWalletInfo.GET_WALLET_INFO_ERROR:
      return {
        ...state,
        loading: false,
      };

      case walletTypes.getAccountBillingDetails.GET_ACCOUNT_BILLING_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case walletTypes.getAccountBillingDetails.GET_ACCOUNT_BILLING_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        billingDetails: action.payload.data
      };
    case walletTypes.getAccountBillingDetails.GET_ACCOUNT_BILLING_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
